<template>         
    <v-tab :href="uiid" @dblclick.native="editTabName" @click.stop.prevent="$store.myActions.MISSION_NAVTO_DETAIL({cmp:tab.cmp,isleft,id:tab.id})" :title="tabTooltip" >        
      <template v-if="edited">
        <drag :transfer-data="{cmp:tab.cmp,isleft,id:tab.id}" class="drag">
          <v-text-field style="margin-top:14px" autofocus @keyup.esc="cancelEdit"  @keyup.enter="closeAndSave" label="Tab Name" v-model="tmpName"></v-text-field>
          <v-spacer />
        </drag>
        <v-btn class="mr-0" small icon @click.prevent.stop="closeAndSave" :title="$t('Pilot.MissionInfos.SaveTooltip')">
          <v-icon small>mdi-content-save</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <drag class="drag" :transfer-data="{cmp:tab.cmp,isleft,id:tab.id}">{{ tryTranslate(tab.label) }}
          <v-spacer />
        </drag>
        <v-btn class="mr-0" small icon @click.prevent.stop="close" :title="$t('Pilot.MissionInfos.CloseDetailTabTooltip')">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-tab>  
</template>
<script>
  import { UiTab } from '@/models/ui/UiTab';
  import { AloMission } from '../../models/alo/AloMission';

  export default {
   name: 'MissionDetailNavTab', 
   props: {
     isleft:Boolean,               
     tab:{
       type:UiTab,
       required:true
     }
   },      
   data() {
      return {
        edited: false,
        tmpName : ""
      }      
   },
   mounted() {      
   },
   computed: {      
      uiid(){
        return `${this.tab.cmp}-${this.tab.id}`
      },  
      tabTooltip(){
        return this.edited?`${this.tab.label} - ${this.$t('Pilot.MissionInfos.EscToCancel')}`:
                      `${this.tab.label} - ${this.$t('Pilot.MissionInfos.DoubleClickToRename')}`
      }
    },
    methods: {  
      tryTranslate(key) {        
        const transKey = `Pilot.MissionDetailMenu.${key}`
        const trad = this.$t(transKey)
        return transKey == trad?key:trad
      },
      close(){
        this.$store.myActions.UI_SET_MEASURETOOL('NONE')
        this.$store.myActions.MISSION_UNSELECT_TAB({cmp:this.tab.cmp,id:this.tab.id,isleft:this.isleft})        
      },
      editTabName() {
        this.tmpName = this.tryTranslate(this.tab.label)
        this.edited = true        
      },
      closeAndSave() {
        this.$store.myActions.MISSION_RENAME_DETAIL({cmp:this.tab.cmp,id:this.tab.id,isleft:this.isleft,label:this.tmpName})
        this.edited = false
      },
      cancelEdit() {                
        this.edited = false
      }
    }
  }
</script>
<style>
.drag{
  display: flex;  
  height: 100%;
  align-items: center;  
}
</style>